import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { AuthStatus } from "../withAuth/authState";

export type PendoProps = {
  guid?: string;
  firstName?: string;
  surname?: string;
  email?: string;
  isElevateAcademic: boolean;
  currentAuthStatus: string;
};

const Pendo = ({
  guid,
  firstName,
  surname,
  email,
  isElevateAcademic,
  currentAuthStatus,
}: PendoProps): null => {
  const { instCode } = useParams();

  useEffect(() => {
    const pendo = window.pendo;

    if (currentAuthStatus === AuthStatus.AUTHORISED && pendo) {
      pendo.initialize({
        visitor: {
          id: guid,
          firstName: firstName,
          surname: surname,
          email: email,
          role: isElevateAcademic ? "academic" : "student",
        },
        account: {
          id: instCode,
          catalyst: true,
        },
      });
    }
  }, [
    currentAuthStatus,
    guid,
    firstName,
    surname,
    email,
    isElevateAcademic,
    instCode,
  ]);

  return null;
};

export default Pendo;
